import { render, staticRenderFns } from "./OrderVolumePerTechnology.vue?vue&type=template&id=66133716"
import script from "./OrderVolumePerTechnology.vue?vue&type=script&lang=ts"
export * from "./OrderVolumePerTechnology.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports